module.exports = "<p>\n  dashboard works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.html
// module id = ./src/app/components/dashboard/dashboard.component.html
// module chunks = main